import { API_GW_URL, BACKEND_URL } from "..";
import { AcademyRegRequestDto, AccreditationRequestDto, PageDto } from "../../types/common";
import { MatchInfo, MatchLinks } from "../../types/fixtures";

export const accreditationRequest = async (
    requestData: AccreditationRequestDto,
) => {
    const response = await fetch(BACKEND_URL + '/services/press/accreditation-request', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
    });

    const data = await response.json();
    if (response.status !== 200) {
        console.error(data);
        return Promise.reject(data);
    }

    return data;
}

export const createConsumableBonus = async (purchaseAmount: number) => {
    const response = await fetch(`${API_GW_URL}/loyalty/create-offline-bonus`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            purchaseAmount,
        })
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data;
}

export const getFixtureById = async (id: number): Promise<MatchInfo> => {
    const response = await fetch(`${BACKEND_URL}/legacy/fixtures/fixture/${id}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json'
        },
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data;
}

export const getFixtureLinks = async (id: number): Promise<MatchLinks> => {
    const response = await fetch(`${BACKEND_URL}/legacy/fixtures/fixture/${id}/links`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json'
        },
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data;
}

export const getPageByName = async (name: string): Promise<PageDto> => {
    const response = await fetch(`${BACKEND_URL}/pages/page-by-name/${name}`, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json'
        },
    });

    if (!response.ok) {
        console.error('Error');
        return Promise.reject(response.statusText);
    }

    const data = await response.json();

    return data;
}

export const regRequest = async (
    requestData: AcademyRegRequestDto,
) => {
    const response = await fetch(BACKEND_URL + '/services/academy/reg-request', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
    });

    const data = await response.json();
    if (response.status !== 200) {
        console.error(data);
        return Promise.reject(data);
    }

    return data;
}
